import { purify } from "../../../../_src/components/purify";

export function searchBids() {
    var btnLoadMore = document.querySelector("[data-action=load-more]")
    var btnsClear = document.querySelectorAll("[data-action=clear]")

    function search(loadMore) {
        var form = document.querySelector('#filter-bids');
        var data = new FormData(form);

        btnLoadMore.classList.add("loading")

        if (!loadMore) {
            document.querySelector("#result-bids").innerHTML = "";
            document.querySelector(".loader-bids").classList.remove("hidden")
        }

        document.querySelectorAll("#filter-bids fieldset").forEach(function(el) {
            el.classList.add("disabled")
        })

        fetch(`/senar/transparencia-e-prestacao-de-contas/licitacoes-e-contratos/ajax/bids.html/p${btnLoadMore.getAttribute("data-page")}?&loadmore=${loadMore}`, {
            method: "POST",
            body: data
        }).then((response) => {
            return response.text();
        }).then((response) => {
            if (loadMore) {
                document.querySelector("#load-more-bids").insertAdjacentHTML('beforebegin', response);

                if (document.querySelector("#result-not-found")) {
                    btnLoadMore.classList.add("hidden")
                    document.querySelector("#result-not-found").remove()
                } else {
                    btnLoadMore.classList.remove("hidden")
                }
            } else {
                document.querySelector("#result-bids").innerHTML = purify(response);
                searchBids();
            }
        })
        .catch((error) => {
            console.error(error);
        })
        .finally(() => {
            if (!loadMore) {
                document.querySelector(".loader-bids").classList.add("hidden")
            }

            btnLoadMore.classList.remove("loading")

            if ( parseInt(btnLoadMore.dataset.page) == parseInt(btnLoadMore.dataset.total) ) {
                btnLoadMore.classList.add('hidden');
            }

            document.querySelectorAll("#filter-bids fieldset").forEach(function(el) {
                el.classList.remove("disabled")
            })
        });
    }

    btnsClear.forEach(function (btn) {
        btn.addEventListener("click", function () { setTimeout(() => { search(false) }, 100), btnLoadMore.dataset.page = "1" }, false)
    })

    btnLoadMore.addEventListener("click", function () { setTimeout(() => { search(true) }, 100), btnLoadMore.dataset.page = parseInt(btnLoadMore.dataset.page) + 1 }, false);

    document.querySelector("#filter-bids").addEventListener("change", function() { setTimeout(() => { search(false) }, 100), btnLoadMore.dataset.page = "1" }, false);
}

if (document.querySelector("#filter-bids")) {
    searchBids();
}
